// extracted by mini-css-extract-plugin
module.exports = {"box":"incidents_box__1EVzG"};